import React, { useState, useEffect } from 'react';
import Header from '../components/layout/Header';
import Drawer from '../components/layout/Drawer';
import SiteFooter from '../components/layout/SiteFooter';
import image3 from '../assets/1.webp';
import VideoSection from '../components/home/VideoSection';
import FacilitiesSection from '../components/home/FacilitiesSection'; // Import FacilitiesSection
import ScrollToBottomButton from '../components/ui/ScrollToBottomButton'; // Import ScrollToBottomButton

export default function InHouseDining() {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false); // State for header scroll effect

  const handleMenuClick = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleDrawerClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>
      <div className={isDrawerOpen ? 'menu-open' : ''}>
        <Header onMenuClick={handleMenuClick} scrolled={scrolled} /> {/* Pass scrolled prop */}
        <Drawer isOpen={isDrawerOpen} onClose={handleDrawerClose} />
        <div className="relative h-[70vh] w-full font-sans text-white overflow-hidden" id="hero"> {/* Add id="hero" for Intersection Observer */}
          {/* Background image */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(${image3})`,
            }}
          />
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/40" />

          {/* Hero content */}
          <main className="relative z-10 flex flex-col items-center justify-center text-center h-[calc(100vh-40px)] px-4">
            <div className="mt-10" />
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-wide" data-aos="fade-up">
              PineRidge Hotel Blossom
            </h1>
            <p className="mt-4 text-lg md:text-xl font-light tracking-[0.2em] uppercase" data-aos="fade-up" data-aos-delay="200">
              In house Dining
            </p>

            {/* CTA button */}
            <button className="mt-8 border border-white px-8 py-3 text-xs md:text-sm tracking-[0.25em] uppercase bg-white/5 hover:bg-white/15 transition" data-aos="fade-up" data-aos-delay="400">
              Browse our menu
            </button>
            <ScrollToBottomButton targetId="in-house-dining-main-content" />
          </main>
        </div>
        <div className="h-[70vh] w-full bg-beige font-sans text-dark-green" data-aos="fade-up">
          {/* Main content */}
          <main className="mx-auto flex max-w-5xl flex-col items-center px-6 pb-10 pt-8 text-sm md:text-base">
            {/* Logo banner / illustration placeholder */}
            <section className="flex flex-col items-center text-center" data-aos="fade-up">
              <div className="mb-4 flex flex-col items-center gap-2">
                <div className="h-9 w-40 border-y border-beige flex items-center justify-center text-xs tracking-[0.3em] uppercase text-beige">
                  Floral Illustration
                </div>
                <h1 className="text-xl md:text-2xl tracking-[0.35em] uppercase text-dark-green">
                  PineRidge Hotel Blossom
                </h1>
                <p className="mt-1 text-[9px] tracking-[0.35em] uppercase text-beige">
                  Restaurant
                </p>
              </div>
            </section>

            {/* Description paragraphs */}
            <section className="mt-4 max-w-3xl space-y-3 leading-relaxed text-dark-green" data-aos="fade-up">
              <p>
                Welcome to PineRidge Hotel Blossom, where traditional cuisine and contemporary
                tastes meet in a charming ambience.
              </p>
              <p>
                Our menu features a delightful fusion of cuisines, crafted with fresh, local
                ingredients to bring out authentic flavours. From gently spiced local dishes
                to classical Indian curries and continental fare, every plate is prepared with
                care and served with warmth.
              </p>
              <p>
                Enjoy your culinary experience while watching the world go by in a cozy and
                inviting setting. PineRidge Hotel Blossom promises a memorable dining experience
                any time you choose to visit.
              </p>
            </section>

            {/* Opening hours */}
            <section className="mt-6 w-full max-w-3xl" data-aos="fade-up">
              <h2 className="text-xs font-semibold tracking-[0.25em] uppercase text-beige">
                Opening Hours
              </h2>

              <div className="mt-3 space-y-2 text-sm text-dark-green">
                <div className="flex items-start gap-2">
                  <div className="mt-[2px] flex h-5 w-5 items-center justify-center rounded-full border border-beige text-[9px]">
                    ⏱
                  </div>
                  <p>
                    <span className="font-medium">Breakfast:</span> 7:00 am – 10:30 am (daily)
                  </p>
                </div>

                <div className="flex items-start gap-2">
                  <div className="mt-[2px] flex h-5 w-5 items-center justify-center rounded-full border border-beige text-[9px]">
                    ⏱
                  </div>
                  <p>
                    <span className="font-medium">Lunch:</span> 12:00 noon – 4:00 pm (daily)
                  </p>
                </div>

                <div className="flex items-start gap-2">
                  <div className="mt-[2px] flex h-5 w-5 items-center justify-center rounded-full border border-beige text-[9px]">
                    ⏱
                  </div>
                  <p>
                    <span className="font-medium">Dinner:</span> 6:30 pm – 10:30 pm, last order at 10:00 pm (daily)
                  </p>
                </div>
              </div>
            </section>

            {/* CTA button */}
            <section className="mt-7" data-aos="fade-up">
              <button className="rounded-none bg-beige px-7 py-2 text-[9px] tracking-[0.3em] uppercase text-dark-green shadow-sm hover:bg-dark-green transition">
                Browse our menu
              </button>
            </section>
          </main>
        </div>
        <VideoSection />
        <FacilitiesSection />
        <SiteFooter />
      </div>
    </>
  );
}
